module.exports = __webpack_public_path__ + "img/small-Linkedin-icon.3025539b.svg";